export default __webpack_public_path__ + "static/media/BhomSinghRathore.7501c7da.jpg";